import React, { useRef, useEffect } from 'react';
import HlsPlayer from 'react-hls-player';

const HLSReactPlayer = ({ src }) => {
  const playerRef = useRef();

  useEffect(() => {
    const video = playerRef.current;

    // Just log when metadata is loaded to show duration is ready
    const onLoadedMetadata = () => {
      console.log('Duration:', video.duration); // Should now be available
    };

    video.addEventListener('loadedmetadata', onLoadedMetadata);

    return () => {
      video.removeEventListener('loadedmetadata', onLoadedMetadata);
    };
  }, []);

  return (
    <HlsPlayer
      playerRef={playerRef}
      src={src}
      autoPlay={false}
      controls={true}
      width="100%"
      height="auto"
      hlsConfig={{
        startPosition: 0,
      }}
    />
  );
};

export default HLSReactPlayer;
